import Head from 'next/head'

import TopSavingsSoldListings from 'modules/RecentListings/TopSavingsSoldListings'
import SignUpA from 'modules/SignUp/SignUpA'

import CaseStudy from './CaseStudy'
import Hero from './Hero'
import HowItWorks from './HowItWorks'
import KeepMoreEquity from './KeepMoreEquity'
import Testimonials from './Testimonials'

const HowItWorksPage = () => (
  <>
    <Head>
      <title>List Your Home in 3 Easy Steps and Sell Fast | HomeLister</title>
      <meta
        name="description"
        content="List your home on major real estate websites for free. Learn how to sell your home fast and how HomeLister works to save your thousands of dollars in fees!"
      />
      <meta
        name="keywords"
        content="How It Works, Sell Your Home Fast, HomeLister"
      />
      <meta
        name="og:description"
        property="og:description"
        content="List your home on major real estate websites for free. Learn how to sell your home fast and how HomeLister works to save your thousands of dollars in fees!"
      />
    </Head>
    <Hero />
    <HowItWorks />
    <KeepMoreEquity />
    <CaseStudy />
    <Testimonials />
    <TopSavingsSoldListings />
    <SignUpA />
  </>
)

export default HowItWorksPage
